import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { InstantSearch, Hits } from 'react-instantsearch/dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

// Actions
import { activeSearchByName } from './actions';

class SearchByName extends Component {

  constructor(props){
    super(props);

    this.state = {
      name: ""
    };
  }

  handleSubmit = () => {
    if (this.state.name.length < 1 || !this.state.name) {
      alert("Please enter a candidate ID.")
    } else if (isNaN(this.state.name)){
      alert("Candidate ID needs to be a number.")
    } else {
      this.props.activeSearchByName();
      this.props.changeRoute("/console/user/"+this.state.name);
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <TextField
          id="name"
          label="Search By Candidate Number"
          className={classes.textField}
          margin="normal"
          value={this.state.name}
          onChange={this.handleChange('name')}
        />
      <Button raised color="primary" align="center" onClick={() => this.handleSubmit()} className={classes.button}>Search</Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    activeSearchByName: () => dispatch(activeSearchByName()),
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(SearchByName)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SearchByName/index.js